<template>
  <div class="">

    <div class="label-standard">{{ label }}</div>

    <div class="mt-3">
      <template v-if="image != null">
        <img :src="image.url"
          style="max-width:150px;"
          class="border-8" />
      </template>

      <template v-else>
        <label 
          :for="'input-upload-' + propertyKey" 
          style="width:150px;height:150px;" 
          class="block border-8 text-center cursor-pointer">
          <div class="text-gray-600 text-xs" style="margin-top:50px;">
            No logo uploaded. <br/> Click to upload.
          </div>
        </label>
      </template>
    </div>

    <div v-if="image != null" class="mt-2">
      <a href="#" v-on:click.prevent="deleteFile(propertyKey)" 
        class="no-underline text-xs uppercase font-semibold text-gray-700 hover:underline hover:text-black">Delete</a>

      &sdot;

      <label 
        :for="'input-upload-' + propertyKey" 
        class="no-underline text-xs uppercase font-semibold text-gray-700 hover:underline hover:text-black">Replace</label>
    </div>

    <input 
      class="hidden"
      :id="'input-upload-' + propertyKey" 
      :ref="'inputFile' + propertyKey"
      type="file" v-on:change="uploadFile($event, propertyKey)" />
  </div>
</template>

<script>

  export default {

    props : {

      label : {
        type : String,
        required : false
      },

      image : {
        type : Object,
        required : false
      },

      propertyKey : {
        type : String,
        required : false
      },

      uploadFile : {
        type : Function,
        required : false
      },

      deleteFile : {
        type : Function,
        required : false
      }
    }
  }
</script>